import { useEffect, useState } from "react"
import bscstakeAbi from '../json/bscstake.json';
import tokenAbi from '../json/token.json';
import { toast } from "react-toastify";
import { DECIMALS, DEFAULT_CHAIN, TAX_WALLETS, contract } from "../helper/constant";
import { getMultiCall } from "../helper/contractHelper";
import { getWeb3 } from "../helper/functions";




export const useCommonStats = (updater) => {

    let web3 = getWeb3();

    

    const [stats, setStats] = useState({
        duration: 0,
        interest: 0,
        totalusers: 0,
        totalstakebnb: 0,
        totalstaketoken: 0,
        totalwithdraw: 0,
        lastWeekWinner: [],
        currentWeekTop: [],
        totalWeekInvestment: 0,
        tokenPrice: 0,
        addliquidity : 0,
        buyback : 0,
        dbb : 0
    });

    let stakeContract = new web3.eth.Contract(bscstakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS);

    useEffect(() => {
        const fetch = async () => {
            try {
                const data = await getMultiCall([
                    stakeContract.methods.duration(), //0
                    stakeContract.methods.interest(), //1
                    stakeContract.methods.totalusers(), //2
                    stakeContract.methods.totalstakebnb(), //3
                    stakeContract.methods.totalstaketoken(), //4
                    stakeContract.methods.totalwithdraw(), //5
                    stakeContract.methods.weekCount(), //6
                    stakeContract.methods.WEEK_REWARD_PERCENTAGE(), //7
                    // stakeContract.methods.getTokenPrice() //8
                ]);

                
                

                const tokenData = await getMultiCall([
                    stakeContract.methods.WeeklyTopUser(data[6]), //0
                    stakeContract.methods.WeeklyTopUser(parseInt(data[6]) > 1 ? parseInt(data[6]) - 1 : 1), //1
                    stakeContract.methods.totalWeekInvestment(data[6]), //2
                ]);

                let buyback = web3.utils.fromWei(await web3.eth.getBalance(TAX_WALLETS.liquiditywallet), 'ether');
                let addliquidity = web3.utils.fromWei(await web3.eth.getBalance(TAX_WALLETS.buybackburn), 'ether');
                let dbb = web3.utils.fromWei(await web3.eth.getBalance(TAX_WALLETS.dailybuyback), 'ether');

    
  
                setStats({
                    duration: data[0],
                    interest: data[1] / 10,
                    totalusers: data[2],
                    totalstakebnb: data[3] / Math.pow(10, 18),
                    totalstaketoken: data[4] / Math.pow(10, DECIMALS),
                    totalwithdraw: data[5] / Math.pow(10, DECIMALS),
                    lastWeekWinner: tokenData[1] ? tokenData[1] : [],
                    currentWeekTop: tokenData[0] ? tokenData[0] : [],
                    totalWeekInvestment: ((tokenData[2] / Math.pow(10, DECIMALS)) * (data[5] / 10)) / 100,
                    tokenPrice: 0, //data[8] / Math.pow(10, 18),
                    buyback,
                    addliquidity,
                    dbb
                })
            }
            catch (err) {
                console.log(err.message);
                toast.error(err.reason)
            }
        }


        fetch();

        // eslint-disable-next-line
    }, [updater]);

    return stats;
}



export const useReferralStats = () => {
    let web3 = getWeb3();
    const [stats, setStats] = useState({
        level: []
    });

    let stakeContract = new web3.eth.Contract(bscstakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS);

    useEffect(() => {
        const fetch = async () => {
            try {
                const data = await getMultiCall([
                    stakeContract.methods.refLevelRate(0), //0
                    stakeContract.methods.refLevelRate(1), //1
                    stakeContract.methods.refLevelRate(2), //2
                    stakeContract.methods.refLevelRate(3), //3
                    stakeContract.methods.refLevelRate(4), //4
                ]);
  
                setStats({
                    level : [data[0] / 10,  data[1] / 10, data[2] / 10, data[3] / 10, data[4] / 10]
                })
            }
            catch (err) {
                console.log(err.message);
                toast.error(err.reason)
            }
        }


        fetch();

        // eslint-disable-next-line
    }, []);

    return stats;
}



